// API Configuration
// Build a robust base URL from env and normalize it
// Default to '/' (relative URLs) to use same-origin proxy through Nginx
const BASE_URL = process.env.REACT_APP_BASE_URL || '/';
// Normalize BASE_URL - ensure it ends with '/' for proper path concatenation
const normalizedBase = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
const API_BASE_URL = `${normalizedBase}api/`;
const AUTH_API_URL = `${normalizedBase}users/`;
console.log('BASE_URL:', BASE_URL);
console.log('normalizedBase:', normalizedBase);
console.log('API_BASE_URL:', API_BASE_URL);
console.log('AUTH_API_URL:', AUTH_API_URL);

// Helper function to add member_email to request data
const addMemberEmailToData = (data, user) => {
  if (user && user.email) {
    return {
      ...data,
      member_email: user.email
    };
  }
  return data;
};

// Helper function to add member_email to headers
const addMemberEmailToHeaders = (headers = {}, user) => {
  if (user && user.email) {
    return {
      ...headers,
      'X-Member-Email': user.email
    };
  }
  return headers;
};

export { API_BASE_URL, AUTH_API_URL, addMemberEmailToData, addMemberEmailToHeaders };